import {
     SET_ADMIN_SURVEY_DETAILS,
     ADD_ADMIN_SURVEY_SECTION,
     UPDATE_ADMIN_SURVEY_SECTION,
     DELETE_ADMIN_SURVEY_SECTION,
     ADD_ADMIN_SURVEY_QUESTION,
     UPDATE_ADMIN_SURVEY_QUESTION,
     DELETE_ADMIN_SURVEY_QUESTION,
     SET_ADMIN_SURVEY_QUESTIONS,
     DELETE_ADMIN_QUESTION_USER_SURVEY_RESULT,
} from './actions';

const INITIAL_STATE = null;

const surveyDetailsReducer = (state = INITIAL_STATE, action) => {
     const surveyDetails = state ? { ...state } : state;
     switch (action.type) {
          // Survey Details
          case SET_ADMIN_SURVEY_DETAILS: {
               return action.payload;
          }

          // Survey Section
          case ADD_ADMIN_SURVEY_SECTION: {
               surveyDetails.surveySections.push(action.payload);
               return surveyDetails;
          }
          case UPDATE_ADMIN_SURVEY_SECTION: {
               const newSections = surveyDetails.surveySections.map((section) => {
                    if (section.id === action.payload.id) {
                         return { ...section, ...action.payload };
                    }
                    return section;
               });
               const newSurveyDetails = {
                    ...surveyDetails,
                    surveySections: newSections,
               };
               return newSurveyDetails;
          }
          case DELETE_ADMIN_SURVEY_SECTION: {
               const newSections = surveyDetails.surveySections.filter((section) => section.id !== action.payload);
               const newSurveyDetails = {
                    ...surveyDetails,
                    surveySections: newSections,
               };
               return newSurveyDetails;
          }

          // Survey Question
          case SET_ADMIN_SURVEY_QUESTIONS: {
               surveyDetails.questions = action.payload;
               return surveyDetails;
          }
          case ADD_ADMIN_SURVEY_QUESTION: {
               surveyDetails.questions.push(action.payload);
               return surveyDetails;
          }
          case UPDATE_ADMIN_SURVEY_QUESTION: {
               const newQuestions = surveyDetails.questions.map((question) => {
                    if (question.id === action.payload.id) {
                         return { ...question, ...action.payload };
                    }
                    return question;
               });
               const newSurveyDetails = {
                    ...surveyDetails,
                    questions: newQuestions,
               };
               return newSurveyDetails;
          }
          case DELETE_ADMIN_SURVEY_QUESTION: {
               const newQuestions = surveyDetails.questions.filter((question) => question.id !== action.payload);
               const newSurveyDetails = {
                    ...surveyDetails,
                    questions: newQuestions,
               };
               return newSurveyDetails;
          }

          case DELETE_ADMIN_QUESTION_USER_SURVEY_RESULT: {
               const newUserSurveys = surveyDetails.userSurveys?.map((userSurvey) => {
                    const results = userSurvey.userSurveyResults[0];
                    const newResults = results.filter((result) => result.questionId !== action.payload);

                    const newUserSurvey = {
                         ...userSurvey,
                         userSurveyResults: [newResults],
                    };

                    return newUserSurvey;
               });
               const newSurveyDetails = {
                    ...surveyDetails,
                    userSurveys: newUserSurveys,
               };
               return newSurveyDetails;
          }

          default:
               return state;
     }
};

export const getSurveySectionById = (state, eid) => state.admin.surveyDetails.surveySections.find((section) => section.id === eid);

export default surveyDetailsReducer;
